import { useMemo } from 'react';

export const useSpeechSupported = (): boolean => {
  return useMemo(() => {
    return window.speechSynthesis && !!window.SpeechSynthesisUtterance;
  }, []);
};
